import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';
import { BulkOrderFormService } from 'src/app/_services/bulk-order-form.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/_services';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-order-type',
  templateUrl: './add-order-type.component.html',
  styleUrls: ['./add-order-type.component.scss']
})
export class AddOrderTypeComponent implements OnInit {
  displayDialog = false;
  orderTypeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private bulkOrderFormService: BulkOrderFormService,
    private ref: DynamicDialogRef,
    private userService: UserService,
    private messageService: MessageService
  ) { 
    this.orderTypeForm = this.fb.group({
      type_name: ['', Validators.required],
      order_size: ['A4'], // or A5, or a dropdown
      is_biocross: [false],
      bulk_order_options: this.fb.array([]),
    });
  }



  ngOnInit(): void {
  }

  get bulk_order_options(): FormArray {
    return this.orderTypeForm.get('bulk_order_options') as FormArray;
  }

  addOption() {
    this.bulk_order_options.push(
      this.fb.group({
        option_name: [''],
        option_value: [''],
      })
    );
  }

  removeOption(index: number) {
    this.bulk_order_options.removeAt(index);
  }

  submit() {
    console.log('orderTypeForm', this.orderTypeForm.value);
    
    if (this.orderTypeForm.valid) {
      if (this.bulk_order_options.length > 0) {
        // add option_value as the same as option_name
        this.bulk_order_options.controls.forEach((control) => {
          control.get('option_value')?.setValue(control.get('option_name')?.value);
        }
        );

        // set biocross to true if the length of bulk_order_options is greater than 0

        this.orderTypeForm.get('is_biocross')?.setValue(true);
      }

      this.bulkOrderFormService.addBulkOrderType(this.orderTypeForm.value).subscribe(
        (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order type created successfully!' });
          this.ref.close(this.orderTypeForm.value);
        },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create order type.' });
        }
      );

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Order Type Created Successfully',
      });
    }
  }

  cancel() {
    this.ref.close();
  }

}
